import { useState } from 'react';
import CreateBundle from '../bundles/CreateBundle';
import ProvesTable from '../table/ProvesTable';

function ProvesTab({
    availableBundles,
    durations,
    availablePlantilles,
    socket,
    onDurationChange,
    loading,
    userId,
}) {
    const [bundleSearch, setBundleSearch] = useState('');
    const [hidePart, setHidePart] = useState({});
    const [showCreateBundleForm, setShowCreateBundleForm] = useState(false);

    const filterBySearch = (bundle) => {
        if (!bundleSearch) return true;
        return (
            bundle?.nom?.toLowerCase()?.includes(bundleSearch) ||
            bundle?.shortName?.toLowerCase()?.includes(bundleSearch) ||
            Object.keys(bundle?.parts || {}).some(part => part.toLowerCase().includes(bundleSearch))
        );
    };

    const visibleBundles = availableBundles.filter(b => !b.hidden).filter(filterBySearch);

    const bundlesAmbPinya = visibleBundles.filter(b =>
        !b.simultani &&
        Object.keys(b.parts || {}).some(p => p === 'Pinya') &&
        !Object.keys(b.parts || {}).every(p => p === 'Tronc')
    );
    const bundlesATerra = visibleBundles.filter(b =>
        !b.simultani &&
        !Object.keys(b.parts || {}).some(p => p === 'Pinya') &&
        !Object.keys(b.parts || {}).filter(p => ['pinya', 'folre', 'manilles', 'puntals', 'tronc'].includes(p.toLowerCase())).every(p => p.toLowerCase() === 'tronc')
    );
    const bundlesNetes = visibleBundles.filter(b =>
        !b.simultani &&
        Object.keys(b.parts || {}).filter(p => ['pinya', 'folre', 'manilles', 'puntals', 'tronc'].includes(p.toLowerCase())).every(p => p.toLowerCase() === 'tronc')
    );
    const bundlesSimultanis = visibleBundles.filter(b => b.simultani);

    const sections = [
        { key: 'pinya', title: 'Proves amb pinya', bundles: bundlesAmbPinya, isSimultani: false },
        { key: 'terra', title: 'Proves a terra', bundles: bundlesATerra, isSimultani: false, visibleParts: ['Folre', 'Manilles', 'Puntals', 'Tronc', 'Organització'] },
        { key: 'netes', title: 'Proves netes', bundles: bundlesNetes, isSimultani: false, visibleParts: ['Tronc', 'Organització'] },
        { key: 'simultanies', title: 'Proves simultànies', bundles: bundlesSimultanis, isSimultani: true },
    ];

    return (
        <div>
            {/* Toolbar */}
            <div className="editor-toolbar">
                <div className="editor-search-wrapper">
                    <input
                        type="text"
                        placeholder="Cerca proves..."
                        value={bundleSearch}
                        onChange={(e) => setBundleSearch(e.target.value.toLowerCase())}
                        className="editor-search-input"
                    />
                    {bundleSearch ? (
                        <button
                            onClick={() => setBundleSearch('')}
                            className="editor-search-clear"
                        >
                            &#10005;
                        </button>
                    ) : null}
                </div>
                <button
                    className="editor-btn-primary"
                    onClick={() => setShowCreateBundleForm(prev => !prev)}
                >
                    + Crea prova
                </button>
            </div>

            {showCreateBundleForm ? (
                <CreateBundle
                    socket={socket}
                    onClose={() => setShowCreateBundleForm(false)}
                />
            ) : null}

            {/* Sections */}
            {sections.map(section => {
                const isCollapsed = hidePart[section.key];
                const isSearchActive = !!bundleSearch;
                const show = isSearchActive ? true : !isCollapsed;

                return (
                    <div key={section.key} className="editor-section">
                        <div
                            className="editor-section-header"
                            onClick={() => setHidePart(prev => ({...prev, [section.key]: !prev[section.key]}))}
                        >
                            <div className="editor-section-header-left">
                                <button className="editor-section-toggle">
                                    {show ? '\u2212' : '+'}
                                </button>
                                <h3 className="editor-section-title">
                                    {section.title}
                                    <span className="editor-section-count">({section.bundles.length})</span>
                                </h3>
                            </div>
                        </div>
                        {show ? (
                            <div className="editor-section-body">
                                <ProvesTable
                                    bundles={section.bundles}
                                    durations={durations}
                                    availablePlantilles={availablePlantilles}
                                    socket={socket}
                                    onDurationChange={onDurationChange}
                                    isSimultani={section.isSimultani}
                                    visibleParts={section.visibleParts}
                                    storageKey={`editor-proves-column-widths-${section.key}`}
                                    loading={loading}
                                    userId={userId}
                                />
                            </div>
                        ) : null}
                    </div>
                );
            })}
        </div>
    );
}

export default ProvesTab;
